export class InstrumentInfoDto {
  id: string | null;
  paymentWallet: string;
  paymentInstrument: string;

  constructor(d?: InstrumentInfoDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.paymentWallet = d.paymentWallet;
    this.paymentInstrument = d.paymentInstrument;
  }
}
